import React from "react";
import { useState, useEffect } from "react";
import CbLogo from "../../Images/CbLogo.svg";
import "./Chatbot.css";
import moment from "moment";
import Copy from "../../Images/Copy.svg";
import arrows from "../../Images/arrows.svg";
import ResponseRenderer from "./ResponseRenderer";
import ChatbotFeedback from "./ChatbotFeedback";

import { toast } from "react-toastify";
import { useRef } from "react";

export const ChatAnswer = ({ response, reGenerateResponse, inputText, errorMessage, remarks, setRemarks, setIsFeedbackMode, sendFeedback, promptId,setErrorMessage }) => {
  const [prmpvalue, setprmpvalue] = useState([]);

  const headLineExtractor = (text) => {
    return text?.split(':')[0];
  };
   
  useEffect(() => {
    if(response){
      setprmpvalue([
        ...prmpvalue,
        {
          prompt: inputText,
          headline: response?.Introductory_text || headLineExtractor(response?.output),
          component: <ResponseRenderer response={response} setErrorMessage={setErrorMessage} />,
          time: moment(new Date()).format("h:mm A"),
          promptLogId: response?.PromptLog
        },
      ]);
    }
  }, [inputText, response]);

  const copyToClipboard = (text) => {
    navigator.clipboard
      .writeText(text)
      .then(() => toast.success("Text copied to clipboard"))
      .catch((err) => toast.error("Failed to copy text"));
  };
  

  return (
    <>
      <div className="w-100 m-auto">
              <div className="pt-5" style={{ marginBottom: "80px" , overflowY: "auto" }}>
          <div>
            <div className="container">
              <div class="widgets py-3">
                <div class="row" id="assettile">
                  {
                    <div>
                      {prmpvalue?.length > 0 &&
                        prmpvalue.map((item, index) => (
                          <div key={index}>
                            <div className="row mt-3">
                              <div className="col-md-8 d-flex justify-content-end ms-auto">
                                <div className="d-flex flex-column mx-2">
                                  <img
                                    className="py-2 SBA_hand "
                                    src={arrows}
                                    onClick={() => {
                                      reGenerateResponse(item.prompt);
                                    }}
                                  />
                                  <img
                                    className="py-2 SBA_hand"
                                    src={Copy}
                                    onClick={()=>{copyToClipboard(item.prompt)}}
                                  />
                                </div>
                                <div
                                  className="card p-3"
                                  style={{ width: "auto" }}
                                >
                                  <div className="d-flex  gap-2">
                                    <i
                                      class="fa fa-user"
                                      aria-hidden="true"
                                    ></i>
                                    <p class="text-dark fw-bold">You</p>
                                    <i
                                      class="fa fa-pencil ms-auto"
                                      aria-hidden="true"
                                    ></i>
                                  </div>
                                  <div className="d-flex mt-2">
                                    <p>{item.prompt}</p>
                                  </div>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-md-12 d-flex justify-content-end"></div>
                                <p className="col-md-12 d-flex justify-content-end">
                                  {item.time}
                                </p>
                              </div>
                            </div>

                            <div className="row d-flex justify-content-start">
                            <div
                              className="p-3 bg-white life-science rounded mt-2"
                              style={{
                                width: "50vw",
                                display: "flex",
                                flexDirection: "column",
                              }}
                              id={item.promptLogId}
                            >
                              <div className="d-flex gap-2" >
                                <img
                                  className="py-2 align-self-start logo-icon"
                                  src={CbLogo}
                                  alt="Logo"
                                />
                                <p className="m-0 fs-4 fw-semibold text-dark">
                                  Asset Edge
                                </p>
                              </div>
                              <p>{item.headline}</p>
                              {item.component} {/* Rendering stored JSX */}
                            </div>
                            </div>
                          </div>
                        ))}
                    </div>
                  }
                <ChatbotFeedback 
                  prompt={inputText} 
                  response={response} 
                  remarks= {remarks}
                  setRemarks={setRemarks}
                  setIsFeedbackMode={setIsFeedbackMode}
                  sendFeedback={sendFeedback}
                  promptId = {promptId}
                />
                </div>
              </div>
            </div>
          </div>
          {errorMessage && (
            <div
              className="alert alert-danger mt-2"
              style={{ textAlign: "center" }}
            >
              {errorMessage}
            </div>
          )}
        </div>
      </div>
    </>
  );
};
